var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChipList',{attrs:{"item":{items: _vm.processes_list},"disable":_vm.disable},on:{"update":_vm.chip_clicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }